<template>
    <v-container v-if="isLoaded" :class="{ menuCategoryProducts: isLoaded }">
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-toolbar flat color="white">
                        <v-btn
                            color="primary"
                            text
                            @click="
                                $router.push({
                                    name: 'menu-categories',
                                    params: { menuId: $route.params.menuId },
                                })
                            "
                        >
                            <v-icon>keyboard_arrow_left</v-icon>
                        </v-btn>
                        <v-toolbar-title>Products</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="openEditProductDialog()"><v-icon>add</v-icon>Create</v-btn>
                        <v-btn icon @click="viewMode = !viewMode"><v-icon>apps</v-icon></v-btn>
                    </v-toolbar>
                </v-card>
            </v-col>
        </v-row>
        <div style="display: flex; flex-direction: column; height: 100%;">
            <v-row v-if="products.length > 0" style="flex: auto auto auto; overflow-y: scroll; height: 0px;">
                <v-col v-if="viewMode" cols="12">
                    <v-data-table :headers="headers" :items="products" :items-per-page="100" class="elevation-1">
                        <template v-slot:item="props">
                            <tr>
                                <td class="text-xs-left">
                                    {{ props.item.order }}
                                </td>
                                <td class="text-xs-left">
                                    {{ props.item | displayLang('title', $store.state.lang) }}
                                </td>
                                <td class="text-xs-left">
                                    {{ props.item | displayLang('description', $store.state.lang) }}
                                </td>
                                <td class="text-xs-left">
                                    <v-img v-if="props.item.image" :src="props.item.image" width="50px" height="50px"></v-img>
                                </td>
                                <td class="text-xs-left">
                                    <v-chip v-for="tag in props.item.menu_tags" :key="tag" label small outlined class="mr-1" color="purple">{{ tag }}</v-chip>
                                </td>
                                <td class="text-xs-left">
                                    {{ props.item.visibility }}
                                </td>
                                <td class="text-xs-left">
                                    {{ props.item.price }}
                                    <span v-if="props.item.price">€</span>
                                    <span v-else> - </span>
                                </td>
                                <td class="text-xs-left">
                                    <v-icon small class="mr-2" @click.stop="openEditProductDialog(props.item)">edit</v-icon>
                                    <v-icon small @click.stop="openDeleteProductDialog(props.item)">delete</v-icon>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-col>
                <v-col v-else cols="12" xs="12" sm="6" md="4" lg="3" xl="2" v-for="product in products" :key="product.id">
                    <v-card max-width="500">
                        <v-img
                            :contain="product.image !== null ? false : false"
                            :src="product.image || defaultImage"
                            height="250px"
                            :class="{ tinted: !product.visibility }"
                            class="white--text align-end"
                        >
                            <v-toolbar absolute max-width flat dark dense width="100%" color="rgba(0, 0, 0, 0.2)">
                                <v-toolbar-title class="title">{{ product.price }}<span v-if="product.price">€</span></v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn icon @click="openEditProductDialog(product)">
                                    <v-icon>edit</v-icon>
                                </v-btn>
                                <v-btn icon @click="openDeleteProductDialog(product)">
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </v-toolbar>
                            <v-card-title>
                                <v-chip v-for="tag in product.menu_tags" :key="tag.id" label small class="mb-9 mr-1" dark color="purple">
                                    {{ tag }}
                                </v-chip>
                            </v-card-title>
                            <!-- <v-toolbar absolute bottom max-width flat dark dense width="100%" color="rgba(63, 191, 191, 0.4)"> -->
                            <v-toolbar absolute bottom max-width flat dark dense width="100%" color="rgba(0, 0, 0, 0.2)">
                                <v-toolbar-title class="subtitle-2">{{ product | displayLang('title', $store.state.lang) }}</v-toolbar-title>
                            </v-toolbar>
                        </v-img>
                    </v-card>
                </v-col>
            </v-row>
            <v-parallax v-else dark style="background-color: #C3C3C3;">
                <v-row align-center column justify="center">
                    <v-col cols="12">
                        <h1 class="display-2 font-weight-thin mb-3">
                            Products
                        </h1>
                        <h4 class="subheading">Category has no products...</h4>
                        <br />
                        <v-btn color="primary" text @click="openEditProductDialog()">Create product</v-btn>
                    </v-col>
                </v-row>
            </v-parallax>
        </div>
        <v-dialog v-model="editProductDialog" width="500" persistent scrollable>
            <v-card>
                <v-toolbar flat color="white">
                    <v-toolbar-title v-if="product.id">{{ $t('menu.editProduct') }}</v-toolbar-title>
                    <v-toolbar-title v-else>{{ $t('menu.newProduct') }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-title>
                        <v-btn v-for="langObject in langs" :key="langObject.value" small icon @click="pickLang(langObject)" :class="{ selected: lang === langObject.value }"
                            ><flag :iso="langObject.icon"
                        /></v-btn>
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text class="py-2">
                    <v-form ref="productForm" v-model="valid" lazy-validation @keydown.native="dialogKeyEventHandler">
                        <v-row dense justify="space-between">
                            <v-col cols="12" v-if="lang === 'english'">
                                <v-text-field
                                    v-model="product.title_en"
                                    ref="title_en"
                                    :label="titleLabel"
                                    prepend-icon="label"
                                    :rules="[rules.required]"
                                    dense
                                    @change="updateTitle()"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" v-if="lang === 'greek'">
                                <v-text-field v-model="product.title_gr" ref="title_gr" :label="titleLabel" prepend-icon="label" dense></v-text-field>
                            </v-col>
                            <v-col cols="12" v-if="lang === 'english'">
                                <v-textarea
                                    v-model="product.description_en"
                                    :label="descriptionLabel"
                                    prepend-icon="description"
                                    dense
                                    rows="2"
                                    @change="updateDescription()"
                                ></v-textarea>
                            </v-col>
                            <v-col cols="12" v-if="lang === 'greek'">
                                <v-textarea v-model="product.description_gr" :label="descriptionLabel" prepend-icon="description" dense rows="2"></v-textarea>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field v-model="product.price" type="number" prepend-icon="euro_symbol" :label="$t('menu.price')" dense></v-text-field>
                            </v-col>
                            <v-col cols="4">
                                <v-text-field v-model="product.order" type="number" :label="$t('menu.order')" prepend-icon="reorder" dense></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-switch class="ml-0 px-0 mt-1" v-model="visibility" :label="$t('menu.visible')"></v-switch>
                            </v-col>
                            <v-col cols="12">
                                <v-autocomplete
                                    v-model="selectedMenuTags"
                                    :items="menuTags"
                                    :label="$t('menu.tags')"
                                    clearable
                                    counter
                                    dense
                                    color="secondary"
                                    item-text="title_en"
                                    return-object
                                    multiple
                                    prepend-icon="local_offer"
                                    style="background: white;"
                                >
                                    <template slot="selection" slot-scope="data">
                                        <v-chip v-if="data.item !== null" :input-value="data.selected" class="chip--select-multi" small>{{ data.item.title_en }}</v-chip>
                                    </template>
                                    <template slot="item" slot-scope="data">
                                        <template v-if="data.item !== null">
                                            <v-list-item-content>
                                                <v-list-item-title small v-html="data.item.title_en" />
                                            </v-list-item-content>
                                        </template>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="imageName"
                                    :label="$t('menu.image')"
                                    :value="product.image"
                                    :placeholder="$t('menu.selectImage')"
                                    class="header-text-field-input"
                                    color="secondary"
                                    prepend-icon="insert_photo"
                                    @click="pickImage"
                                />
                                <input ref="image" type="file" style="display: none" accept="image/*" @change="setImage" />
                                <v-img v-if="product.image" id="avatar" :src="getLogo" alt="avatar" contain class="my-0 ml-4"></v-img>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="gray" text @click="editProductDialog = false">{{ $t('generic.close') }}</v-btn>
                    <v-btn color="error" text @click="validate()">
                        <span v-if="product.id">{{ $t('generic.update') }}</span>
                        <span v-else>{{ $t('generic.create') }}</span>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="deleteProductDialog" width="400">
            <v-card>
                <v-toolbar flat color="white">
                    <v-toolbar-title>{{ $t('menu.deleteProduct') }} {{ product.title_en }}</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    {{ $t('menu.deleteProductQuestion') }}
                    {{ product.title_en }}?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="gray" text @click="deleteProductDialog = false">{{ $t('generic.close') }}</v-btn>
                    <v-btn color="error" text @click="deleteProduct()">{{ $t('generic.delete') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import * as R from 'ramda';
import { MenuApi } from '@/api';
import { dates, fonts, filters } from '@/utils/mixins';
import { SET_SNACKBAR_STATUS } from '@/store/mutation-types';

export default {
    name: 'Menu',
    mixins: [dates, fonts, filters],
    data() {
        return {
            isLoaded: false,
            visibility: true,
            viewMode: true,
            businessId: null,
            titleLabel: `${this.$t('menu.title')} - ${this.$t('langs.en')}`,
            descriptionLabel: `${this.$t('menu.description')} - ${this.$t('langs.en')}`,
            categoryId: null,
            menu: null,
            category: null,
            valid: true,
            menuTags: [],
            selectedMenuTags: [],
            products: [],
            product: {},
            editProductDialog: false,
            deleteProductDialog: false,
            lang: 'english',
            langs: [
                {
                    text: 'English',
                    value: 'english',
                    icon: 'gb',
                },
                {
                    text: 'Greek',
                    value: 'greek',
                    icon: 'gr',
                },
            ],
            headers: [
                {
                    text: 'Order',
                    value: 'order',
                    align: 'left',
                    width: '5%',
                    sortable: true,
                },
                {
                    text: 'Title',
                    value: 'title_en',
                    align: 'left',
                    width: '20%',
                    sortable: true,
                },
                {
                    text: 'Description',
                    value: 'description_en',
                    align: 'left',
                    width: '20%',
                    sortable: false,
                },
                {
                    text: 'Image',
                    value: 'image',
                    align: 'left',
                    width: '5%',
                    sortable: false,
                },
                {
                    text: 'Tags',
                    value: 'menu_tags',
                    align: 'left',
                    width: '15%',
                    sortable: false,
                },
                {
                    text: 'Visible',
                    value: 'visibility',
                    align: 'left',
                    width: '5%',
                    sortable: true,
                },
                {
                    text: 'Price',
                    value: 'price',
                    align: 'left',
                    width: '5%',
                    sortable: true,
                },
                {
                    align: '',
                    sortable: false,
                    text: 'Actions',
                    value: 'action',
                    width: '5%',
                },
            ],
            rules: {
                required: value => !!value || this.$t('rules.required'),
            },
            imageName: null,
            imageUrl: require('../../../../assets/product_bg.jpg'),
            defaultImage: require('../../../../assets/product_bg.jpg'),
        };
    },
    computed: {
        getLogo: {
            get() {
                if (['', null, undefined].includes(this.product.image) || this.product.image instanceof FormData) {
                    return this.imageUrl;
                }
                return this.product.image;
            },
        },
    },
    async created() {
        this.businessId = this.$route.params.id;
        this.categoryId = this.$route.params.categoryId;
        await this.loadMenuTags();
        await this.loadMenu();
        await this.loadCategory();
        await this.loadProducts();
        this.isLoaded = true;
    },
    methods: {
        dialogKeyEventHandler(event) {
            if (event.key === 'Escape') {
                this.editProductDialog = false;
            }

            if (event.ctrlKey && event.key === '1') {
                event.preventDefault();
                this.pickLang(this.langs[0]);
            }
            if (event.ctrlKey && event.key === '2') {
                event.preventDefault();
                this.pickLang(this.langs[1]);
            }
            if (event.shiftKey && event.key === 'Enter') {
                this.validate();
                this.openEditCategoryDialog();
            } else if (event.key === 'Enter') {
                this.validate();
            }
        },
        updateTitle() {
            if (this.product.title_gr === null || this.product.title_gr === undefined) {
                this.product.title_gr = this.product.title_en;
            }
        },
        updateDescription() {
            if (this.product.description_gr === null || this.product.description_gr === undefined) {
                this.product.description_gr = this.product.description_en;
            }
        },
        pickLang(selectedLang) {
            this.lang = selectedLang.value;
            this.$nextTick(() => {
                if (this.lang === 'english') {
                    this.$refs.title_en.focus();
                    this.titleLabel = `${this.$t('menu.title')} - ${this.$t('langs.en')}`;
                    this.descriptionLabel = `${this.$t('menu.description')} - ${this.$t('langs.en')}`;
                }
                if (this.lang === 'greek') {
                    this.$refs.title_gr.focus();
                    this.titleLabel = `${this.$t('menu.title')} - ${this.$t('langs.gr')}`;
                    this.descriptionLabel = `${this.$t('menu.description')} - ${this.$t('langs.gr')}`;
                }
            });
        },
        validate() {
            if (this.$refs.productForm.validate()) {
                this.updateProduct();
            }
        },
        reset() {
            if (this.$refs.productForm) {
                this.$refs.productForm.reset();
                this.lang = 'english';
                this.pickLang(this.langs[0]);
            }
            if (this.$refs.image) {
                this.$refs.image.value = '';
            }
            this.product.image = null;
            this.imageName = null;
            this.$nextTick(() => {
                this.visibility = true;
            });
        },
        async loadMenu() {
            try {
                const { data: menu } = await MenuApi.get(this.$route.params.menuId);
                this.menu = menu;
            } catch (e) {
                this.menu = null;
            }
        },
        async loadCategory() {
            const { data: category } = await MenuApi.getCategory(this.categoryId);
            this.category = category;
        },
        async loadProducts() {
            const { data: products } = await MenuApi.getProducts({
                category: this.categoryId,
            });
            this.products = products;
        },
        async loadMenuTags() {
            const { data: menuTags } = await MenuApi.getMenuTags();
            this.menuTags = menuTags;
        },
        openEditProductDialog(product) {
            this.lang = 'english';
            this.reset();
            if (product === undefined) {
                this.product = {};
            } else {
                this.$nextTick(() => {
                    this.visibility = this.product.visibility;
                });
                this.selectedMenuTags = this.menuTags.filter(menuTag => product.menu_tags.find(businessMenuTag => menuTag.title_en === businessMenuTag));
                this.product = R.clone(product);
            }
            this.editProductDialog = true;
            this.$nextTick(() => {
                this.$nextTick(() => {
                    this.$refs.title_en.focus();
                });
            });
        },
        async updateProduct() {
            this.product.visibility = this.visibility;
            this.product.category = this.categoryId;
            this.product.menu_tags = [];
            this.selectedMenuTags.forEach(menuTag => {
                this.product.menu_tags.push(menuTag.id);
            });
            if (this.product.id) {
                const tempProduct = R.clone(this.product);
                delete tempProduct.image;
                const { data: product } = await MenuApi.updateProduct(tempProduct);
                if (this.product.image instanceof FormData) {
                    const headers = { 'Content-Type': 'multipart/form-data' };
                    const { data: productWithImage } = await MenuApi.uploadProductImage(product.id, this.product.image, headers);
                    this.product = productWithImage;
                } else {
                    this.product = product;
                }
            } else {
                const tempProduct = R.clone(this.product);
                delete tempProduct.image;
                const { data: product } = await MenuApi.createProduct(tempProduct);
                if (this.product.image instanceof FormData) {
                    const headers = { 'Content-Type': 'multipart/form-data' };
                    const { data: productWithImage } = await MenuApi.uploadProductImage(product.id, this.product.image, headers);
                    this.product = productWithImage;
                } else {
                    this.product = product;
                }
            }
            this.loadProducts();
            this.$store.commit(SET_SNACKBAR_STATUS, {
                message: 'Product created!',
                color: 'success',
            });
            this.editProductDialog = false;
            this.product = {};
        },
        openDeleteProductDialog(product) {
            this.product = product;
            this.deleteProductDialog = true;
        },
        async deleteProduct() {
            await MenuApi.deleteProduct(this.product.id);
            this.loadProducts();
            this.$store.commit(SET_SNACKBAR_STATUS, {
                message: `Product ${this.product.title_en}`,
                color: 'success',
            });
            this.deleteProductDialog = false;
            this.product = {};
        },
        pickImage() {
            this.$refs.image.click();
        },
        setImage(e) {
            const file = e.target.files[0];
            // if (!file.type.includes('image/')) {
            //     this.imageName = '';
            //     this.imageUrl = this.fileIcon;
            //     return;
            // }
            if (typeof FileReader === 'function') {
                const reader = new FileReader();
                reader.onload = event => {
                    this.imageName = e.target.files[0].name;
                    const [imageFile] = e.target.files;
                    this.imageUrl = event.target.result;
                    const formData = new FormData();
                    formData.append('image', imageFile);
                    this.product.image = formData;
                };
                reader.readAsDataURL(file);
            }
            // else {
            //     this.imageName = '';
            //     this.imageUrl = this.fileIcon;
            // }
        },
    },
};
</script>

<style scoped>
.menuCategoryProducts {
    height: calc(100% - 60px);
}
.dark {
    background-color: blue;
}
.tinted {
    opacity: 0.5;
}
.selected {
    background-color: rgba(100, 200, 300, 0.8);
}
</style>
